/**
 * POST `admin/clients/:id/subscription/block` — закрыть клинике запись
 * решением Skrezo (не из-за оплаты). Клиника уходит в режим чтения, статус
 * «Заблокирована»; снимается повторной активацией. Причина — в историю.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_CLIENTS} from '../mocks';

import {type AdminSubscription, toAdminSubscription} from './activateSubscription';

export type BlockSubscriptionInput = {id: string; reason: string};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const blockSubscription = async (
  input: BlockSubscriptionInput,
): Promise<AdminSubscription> => {
  if (!apiEnabled) {
    await sleep(400);
    const row = MOCK_CLIENTS.find((c) => c.id === input.id);
    if (row) row.subscriptionStatus = 'blocked';
    return {
      status: 'blocked',
      currentPeriodEnd: row?.currentPeriodEnd ?? null,
      writesBlocked: true,
    };
  }
  return toAdminSubscription(
    await http(`admin/clients/${encodeURIComponent(input.id)}/subscription/block`, {
      method: 'POST',
      body: {reason: input.reason.trim() !== '' ? input.reason.trim() : null},
      skipCaseConversion: true,
    }),
  );
};
